// assets
import { SendOutlined } from '@ant-design/icons';

// icons
const icons = { SendOutlined };

// ==============================|| MENU ITEMS - MOVIMIENTOS ||============================== //

const movimientos = {
  id: 'movimientos',
  title: 'Movimientos',
  type: 'group',
  children: [
    {
      id: 'envios',
      title: 'Envíos',
      type: 'item',
      url: '/envios',
      icon: icons.SendOutlined
    }
  ]
};

export default movimientos;
